import { render, staticRenderFns } from "./CoverConfig.vue?vue&type=template&id=29d55124&scoped=true&"
import script from "./CoverConfig.vue?vue&type=script&lang=js&"
export * from "./CoverConfig.vue?vue&type=script&lang=js&"
import style0 from "./CoverConfig.vue?vue&type=style&index=0&id=29d55124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d55124",
  null
  
)

export default component.exports